import { render, staticRenderFns } from "./student_data.vue?vue&type=template&id=64875342&scoped=true"
import script from "./student_data.vue?vue&type=script&lang=js"
export * from "./student_data.vue?vue&type=script&lang=js"
import style0 from "./student_data.vue?vue&type=style&index=0&id=64875342&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64875342",
  null
  
)

export default component.exports